import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../styles/OffersSection/OffersHeader.scss";
export const OffersHeader = () => {
  const isMobile = useMediaQuery("(max-width:800px)");
  const { t } = useTranslation();

  return (
    <div
      style={{ display: isMobile ? "block" : "flex" }}
      className="OffersHeader"
    >
      <h2>
        {t("offers_header_title")} <span>{t("offers_header_subtitle")}</span>
      </h2>
    </div>
  );
};
